import { Empty } from "antd";
import { showError, showSuccess, showWarning } from "common/ToastNotifications";
import {
    BasicFormBuilder,
    DataSetExport,
    DataSetList,
    DeduplicatedRecordsTable,
    EmptyDataRow,
    LoadingOverlay,
    ManageDataSet,
    NotFoundError,
    OkCancelConfirmationBox,
    ProhibitedArea,
    SuccessResult,
} from "components";
import MenuPanelContainer from "components/atoms/MenuPanelContainer";
import AppPaths from "constants/appPaths";
import { DataObjectConsents, DataObjectVerifications, DataSetAudit } from "containers";
import flatten from "flat";
import _ from "lodash";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";
import LocationContainer from "./LocationMain";

class DataSets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchingSchemaDataSets: false,
            fetchingDataSetPermission: false,
            fetchingDataSet: false,
            busy: false,
            busyMessage: "Please wait...",
            manageDataSetErrors: {},
            showExportJobCreatedResult: false,
            showExportJobToSystemConnectionCreatedResult: false,
            sidePanelActiveTab: "DATASET_RECORD",
        };
    }

    componentWillMount() {
        this.props.getDataObjectPermission();
        if (this.props.action) {
            this.showBreadCrumbNavigationItems();
            if (this.props.action === "history") {
                this.setState({
                    showHistory: false,
                });
            }
            this.setState({
                fetchingDataSetPermission: true,
            });
            this.props.getUserDataSetPermission();

            if (this.props.dataSetId) {
                this.setState({
                    fetchingDataSet: true,
                });
                this.props.getDataSetById(this.props.schemaModel.businessAreaId, this.props.schemaModel.schemaId, this.props.dataSetId);
            }
        } else {
            if (this.props.selectedSchemaModel) {
                this.setState({
                    fetchingSchemaDataSets: true,
                    fetchingDataSetPermission: true,
                });
                this.props.getDataSetBySchemaId(this.props.selectedSchemaModel.businessAreaId, this.props.selectedSchemaModel.schemaId);
                this.props.getUserDataSetPermission();
                this.props.getUserExportJobPermission();
            }
        }
    }

    componentDidMount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetUserDataSetPermissionResultChanged(prevProps);
        this.onGetSchemaDataSetResultChanged(prevProps);
        this.onCreateDataSetResultChanged(prevProps);
        this.onUpdateDataSetResultChanged(prevProps);
        this.onDeleteDataSetResultChanged(prevProps);
        this.onGetDataSetByIdResultChanged(prevProps);
        this.onGetDataObjectsByDataSetIdResultChanged(prevProps);
        this.onGetDataObjectsByDataSetIdNextPageResultChanged(prevProps);
        this.onGetJobsResultChanged(prevProps);
        this.onUndoJobResultChanged(prevProps);
        this.onIndexDataSetResultChanged(prevProps);
        this.onExportDataSetToFileResultChanged(prevProps);
        this.onExportDataSetToSystemConnectionResultChanged(prevProps);
        this.onCreateDataObjectResultChanged(prevProps);
        this.onUpdateDataObjectResultChanged(prevProps);
        this.onDeleteDataObjectResultChanged(prevProps);
        this.onGetDataObjectResultChanged(prevProps);
        this.onGetDeDuplicatedRecordsRequestResultChanged(prevProps);
        this.onGetDataObjectPermissionResultChanged(prevProps);
    }

    onGetDataObjectPermissionResultChanged = (prevProps) => {
        if (this.props.getDataObjectPermissionResult && this.props.getDataObjectPermissionResult !== prevProps.getDataObjectPermissionResult) {
            if (!this.props.getDataObjectPermissionResult.success || !this.props.dataObjectPermission || !this.props.dataObjectPermission.canEdit) {
                this.setState({
                    permissionToEditDataObjectDenied: true,
                });
            }
            this.setState({
                fetchingPermission: false,
            });
        }
    };

    showBreadCrumbNavigationItems = () => {
        if (this.props.setBreadcrumbNavigationItems) {
            let breadCrumbItems = [
                {
                    route: AppPaths.TENANT_HOME.replace(":tenant", this.props.tenant.toLowerCase()),
                    text: "Home",
                },
                {
                    route: AppPaths.TENANT_BUSINESS_AREA_SCHEMA.replace(":tenant", this.props.tenant.toLowerCase()).replace(":businessarea", this.props.businessArea.toLowerCase()),
                    text: "Schemas",
                },
                {
                    route: AppPaths.TENANT_BUSINESS_AREA_SCHEMA_ID.replace(":tenant", this.props.tenant.toLowerCase())
                        .replace(":businessarea", this.props.businessArea.toLowerCase())
                        .replace(":schemaId", this.props.schemaModel.schemaId),
                    text: this.props.schema,
                },
                {
                    route: `${AppPaths.TENANT_BUSINESS_AREA_SCHEMA.replace(":tenant", this.props.tenant.toLowerCase()).replace(
                        ":businessarea",
                        this.props.businessArea.toLowerCase(),
                    )}${this.props.schemaModel ? `#${this.props.schemaModel.name}` : ""}`,
                    text: "Datasets",
                },
            ];
            if (this.props.action) {
                let dataSetName = "";
                switch (this.props.action.toLowerCase()) {
                    case "create":
                        breadCrumbItems.push({
                            route: "",
                            text: "New Dataset",
                        });
                        break;
                    case "view":
                    case "edit":
                        breadCrumbItems.push(
                            ...[
                                {
                                    route: "",
                                    text: this.getDataSetName(),
                                },
                            ],
                        );
                        break;
                    case "history":
                        dataSetName = this.getDataSetName();
                        breadCrumbItems.push(
                            ...[
                                {
                                    route: "",
                                    text: dataSetName,
                                },
                                {
                                    route: "",
                                    text: "History",
                                },
                            ],
                        );
                        break;
                    case "export":
                        dataSetName = this.getDataSetName();
                        breadCrumbItems.push(
                            ...[
                                {
                                    route: "",
                                    text: dataSetName,
                                },
                                {
                                    route: "",
                                    text: "Export",
                                },
                            ],
                        );
                        break;
                    default:
                        // Always include a default break
                        break;
                }
            }

            this.props.setBreadcrumbNavigationItems(breadCrumbItems);
        }
    };

    getDataSetName = () => {
        let dataSetName = "";
        if (this.props.dataSet && this.props.dataSet.dataSetId === this.props.dataSetId) {
            dataSetName = this.props.dataSet.dataSetName;
        }

        if (!dataSetName && this.props.schemaDataSetResult && this.props.schemaDataSetResult.Items && this.props.schemaDataSetResult.Items.length > 0) {
            let dataSet = this.props.schemaDataSetResult.Items.find((dataSet) => dataSet.dataSetId === this.props.dataSetId);
            if (dataSet) {
                dataSetName = dataSet.dataSetName;
            }
        }
        if (!dataSetName && this.props.recentDataSetListResult && this.props.recentDataSetListResult.Items && this.props.recentDataSetListResult.Items.length > 0) {
            let dataSet = this.props.recentDataSetListResult.Items.find((dataSet) => dataSet.dataSetId === this.props.dataSetId);
            if (dataSet) {
                dataSetName = dataSet.dataSetName;
            }
        }
        if (!dataSetName) {
            dataSetName = this.props.dataSetId;
        }
        return dataSetName;
    };

    onGetUserDataSetPermissionResultChanged = (prevProps) => {
        if (this.props.getUserDataSetPermissionResult && this.props.getUserDataSetPermissionResult !== prevProps.getUserDataSetPermissionResult) {
            if (!this.props.getUserDataSetPermissionResult.success || !this.props.dataSetPermission) {
                this.setState({
                    permissionDenied: true,
                });
            } else {
                this.setDataSetPermissions(this.props.dataSetPermission, this.props.userBusinessArea);
            }
            this.setState({
                fetchingDataSetPermission: false,
            });
        }
    };

    onGetSchemaDataSetResultChanged = (prevProps) => {
        if (this.props.getSchemaDataSetResult && this.props.getSchemaDataSetResult !== prevProps.getSchemaDataSetResult) {
            if (!this.props.getSchemaDataSetResult.success) {
                if (this.props.getSchemaDataSetResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true,
                    });
                } else {
                    showError("Could not able to get schema datasets.");
                }
            }
            this.setState({
                fetchingSchemaDataSets: false,
            });
        }
    };

    onCreateDataSetResultChanged = (prevProps) => {
        if (this.props.createDataSetResult && this.props.createDataSetResult !== prevProps.createDataSetResult) {
            if (!this.props.createDataSetResult.success) {
                if (this.props.createDataSetResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        busy: false,
                    });
                    showError("Could not able to create dataset. Permission Denied.");
                } else {
                    this.setState({
                        busy: false,
                        manageDataSetErrors: this.props.createDataSetResult.fields,
                    });
                    showError("Could not able to create dataset.");
                }
            } else {
                this.setState({
                    manageDataSetErrors: null,
                });
                if (this.state.afterSaveCallback) {
                    this.state.afterSaveCallback();
                } else {
                    this.setState({
                        busy: true,
                        busyMessage: "Dataset created. Please wait...",
                    });
                    showSuccess("Dataset created successfully.", () => {
                        this.goToSchemas();
                    });
                }
            }
            this.setState({
                afterSaveCallback: null,
            });
        }
    };

    onUpdateDataSetResultChanged = (prevProps) => {
        if (this.props.updateDataSetResult && this.props.updateDataSetResult !== prevProps.updateDataSetResult) {
            if (!this.props.updateDataSetResult.success) {
                if (this.props.updateDataSetResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        busy: false,
                    });
                    showError("Could not able to update dataset. Permission Denied.");
                } else {
                    this.setState({
                        busy: false,
                        manageDataSetErrors: this.props.updateDataSetResult.fields,
                    });
                    showError("Could not able to update dataset.");
                }
            } else {
                this.setState({
                    manageDataSetErrors: null,
                });
                if (this.state.afterSaveCallback) {
                    this.state.afterSaveCallback();
                } else {
                    this.setState({
                        busy: true,
                        busyMessage: "Dataset updated. Please wait...",
                    });
                    showSuccess("Dataset updated successfully.", () => {
                        this.goToSchemas();
                    });
                }
            }
            this.setState({
                afterSaveCallback: null,
            });
        }
    };

    onDeleteDataSetResultChanged = (prevProps) => {
        if (this.props.deleteDataSetResult && this.props.deleteDataSetResult !== prevProps.deleteDataSetResult) {
            if (!this.props.deleteDataSetResult.success) {
                if (this.props.deleteDataSetResult.code === "PERMISSION_DENIED") {
                    showError("Permission denied!");
                } else {
                    showError("Could not able to delete dataset.");
                }
            } else {
                showSuccess("Dataset deleted successfully.");
            }
            this.setState({
                busy: false,
                busyMessage: "",
            });
        }
    };

    onGetDataSetByIdResultChanged = (prevProps) => {
        if (this.props.getDataSetByIdResult && this.props.getDataSetByIdResult !== prevProps.getDataSetByIdResult) {
            if (!this.props.getDataSetByIdResult.success) {
                if (this.props.getDataSetByIdResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true,
                    });
                } else {
                    showError("Could not able to get dataset.");
                }
            } else {
                if (!this.props.schemaDataSetResult || !this.props.schemaDataSetResult.Items || this.props.schemaDataSetResult.Items.length === 0) {
                    this.showBreadCrumbNavigationItems();
                }
                if (this.props.action === "history") {
                    this.setState({
                        showHistory: true,
                    });
                } else {
                    if (this.props.dataSet) {
                        this.getDataSetObjects();
                    }
                }
            }
            this.setState({
                fetchingDataSet: false,
            });
        }
    };

    onGetDataObjectsByDataSetIdResultChanged = (prevProps) => {
        if (this.props.getDataObjectsByDataSetIdResult && this.props.getDataObjectsByDataSetIdResult !== prevProps.getDataObjectsByDataSetIdResult) {
            if (!this.props.getDataObjectsByDataSetIdResult.success) {
                if (this.props.getDataObjectsByDataSetIdResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        dataObjectsPermissionDenied: true,
                    });
                } else {
                    showError("Could not able to get data objects.");
                }
            }
            this.setState({
                fetchingDataObjects: false,
            });
        }
    };

    onGetDataObjectsByDataSetIdNextPageResultChanged = (prevProps) => {
        if (this.props.getDataObjectsByDataSetIdNextPageResult && this.props.getDataObjectsByDataSetIdNextPageResult !== prevProps.getDataObjectsByDataSetIdNextPageResult) {
            if (!this.props.getDataObjectsByDataSetIdNextPageResult.success) {
                if (this.props.getDataObjectsByDataSetIdNextPageResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        dataObjectsPermissionDenied: true,
                    });
                } else {
                    showError("Could not able to get data objects.");
                }
            }
            this.setState({
                fetchingNextPageDataObjects: false,
            });
        }
    };

    onGetJobsResultChanged = (prevProps) => {
        if (this.props.getJobsResult && this.props.getJobsResult !== prevProps.getJobsResult) {
            if (!this.props.getJobsResult.success) {
                showError("Could not able to get batch upload jobs.");
            }
            this.setState({
                fetchingDataSetJobs: false,
            });
        }
    };

    onUndoJobResultChanged = (prevProps) => {
        if (this.props.undoJobResult && this.props.undoJobResult !== prevProps.undoJobResult) {
            if (!this.props.undoJobResult.success) {
                showError("Could not able to undo job.");
            }
            this.setState({
                undoJobInProgress: false,
            });
        }
    };

    onIndexDataSetResultChanged = (prevProps) => {
        if (this.props.indexDataSetResult && this.props.indexDataSetResult !== prevProps.indexDataSetResult) {
            if (!this.props.indexDataSetResult.success) {
                showError("Could not able to create dataset records index job.");
            } else {
                showSuccess("Index dataset records job created successfully.");
            }
            this.setState({
                busy: false,
                busyMessage: "",
            });
        }
    };

    onExportDataSetToFileResultChanged = (prevProps) => {
        if (this.props.exportDataSetToFileResult && this.props.exportDataSetToFileResult !== prevProps.exportDataSetToFileResult) {
            if (!this.props.exportDataSetToFileResult.success) {
                showError("Could not able to create export dataset job.");
            } else {
                this.setState({
                    showExportJobCreatedResult: true,
                });
            }
            this.setState({
                busy: false,
                busyMessage: "",
            });
        }
    };

    onExportDataSetToSystemConnectionResultChanged = (prevProps) => {
        if (this.props.exportDataSetToSystemConnectionResult && this.props.exportDataSetToSystemConnectionResult !== prevProps.exportDataSetToSystemConnectionResult) {
            if (!this.props.exportDataSetToSystemConnectionResult.success) {
                showError("Could not able to create export dataset job.");
            } else {
                this.setState({
                    showExportJobToSystemConnectionCreatedResult: true,
                });
            }
            this.setState({
                busy: false,
                busyMessage: "",
            });
        }
    };

    onCreateDataObjectResultChanged = (prevProps) => {
        if (this.props.createDataObjectResult && this.props.createDataObjectResult !== prevProps.createDataObjectResult) {
            if (!this.props.createDataObjectResult.success) {
                if (this.props.createDataObjectResult.code === "PERMISSION_DENIED") {
                    showError("Permission denied!");
                } else {
                    showError("Could not able to create dataset record.");
                }
            } else {
                if (this.state.selectedDataObject) {
                    let selectedDataObject = this.props.dataObjectsByDataSetIdResult.Items[0];
                    this.setState({
                        selectedDataObject,
                    });
                    if (selectedDataObject.errors && selectedDataObject.errors.length > 0) {
                        showWarning("Record created successfully with warnings.");
                    } else {
                        showSuccess("Record created successfully.");
                    }
                }
            }
            this.setState({
                busy: false,
                busyMessage: "",
            });
        }
    };

    onUpdateDataObjectResultChanged = (prevProps) => {
        if (this.props.updateDataObjectResult && this.props.updateDataObjectResult !== prevProps.updateDataObjectResult) {
            if (!this.props.updateDataObjectResult.success) {
                if (this.props.updateDataObjectResult.code === "PERMISSION_DENIED") {
                    showError("Permission denied!");
                } else {
                    showError("Could not able to update dataset record.");
                }
            } else {
                if (this.state.selectedDataObject) {
                    let selectedDataObject = this.props.dataObjectsByDataSetIdResult.Items.find(
                        (dataObject) => dataObject.dataObjectId === this.state.selectedDataObject.dataObjectId,
                    );
                    if (selectedDataObject) {
                        this.setState({
                            selectedDataObject,
                        });
                        if (selectedDataObject.errors && selectedDataObject.errors.length > 0) {
                            showWarning("Record saved successfully with warnings.");
                        } else {
                            showSuccess("Record saved successfully.");
                        }
                    } else {
                        showSuccess("Record saved successfully.");
                    }
                }
            }
            this.setState({
                busy: false,
                busyMessage: "",
            });
        }
    };

    onDeleteDataObjectResultChanged = (prevProps) => {
        if (this.props.deleteDataObjectResult && this.props.deleteDataObjectResult !== prevProps.deleteDataObjectResult) {
            if (!this.props.deleteDataObjectResult.success) {
                showError("Could not able to delete dataset record.");
            } else {
                if (this.state.selectedDataObject) {
                    this.setState({
                        selectedDataObject: null,
                    });
                    showSuccess("Record deleted successfully.");
                }
            }
            this.setState({
                busy: false,
                busyMessage: "",
            });
        }
    };

    onGetDataObjectResultChanged = (prevProps) => {
        if (this.props.getDataObjectResult && this.props.getDataObjectResult !== prevProps.getDataObjectResult) {
            if (this.props.getDataObjectResult.success) {
                if (this.state.selectedDataObject && this.props.dataObject && this.state.selectedDataObject.dataObjectId === this.props.dataObject.dataObjectId) {
                    this.setState({
                        selectedDataObject: this.props.dataObject,
                    });
                }
            }
        }
    };

    onGetDeDuplicatedRecordsRequestResultChanged = (prevProps) => {
        if (this.props.getDeDuplicatedRecordsRequestResult && this.props.getDeDuplicatedRecordsRequestResult !== prevProps.getDeDuplicatedRecordsRequestResult) {
            if (!this.props.getDeDuplicatedRecordsRequestResult.success) {
                showError("Could not able to get deduplicated records.");
            }
            this.setState({
                fetchingDeDuplicatedRecords: false,
            });
        }
    };

    getDataSetObjects = () => {
        this.setState({
            fetchingDataObjects: true,
        });
        this.props.getDataObjectsByDataSetId(this.props.schemaModel.businessAreaId, this.props.schemaModel.schemaId, this.props.dataSet.dataSetId);
    };

    loadingComponentData = () => {
        return this.state.fetchingDataSet || this.state.fetchingDataSetPermission || this.state.fetchingSchemaDataSets;
    };

    isBusy = () => {
        let isBusy = this.state.busy || this.loadingComponentData();
        return isBusy;
    };

    setDataSetPermissions = (permission, userBusinessArea) => {
        let dataSetPermission = {
            canAdd: false,
            canView: false,
            canEdit: false,
            canDelete: false,
        };
        if (permission && userBusinessArea && userBusinessArea.user) {
            dataSetPermission = {
                canAdd: permission.canAdd && userBusinessArea.user.canAdd,
                canView: permission.canView && userBusinessArea.user.canView,
                canEdit: permission.canEdit && userBusinessArea.user.canEdit,
                canDelete: permission.canDelete && userBusinessArea.user.canDelete,
            };
        }
        this.setState({
            dataSetPermission,
        });
    };

    showCreateDataSet = () => {
        this.props.history.push(
            AppPaths.TENANT_SCHEMA_DATASET_ACTION.replace(":tenant", this.props.tenant.toLowerCase())
                .replace(":businessarea", this.props.businessArea.toLowerCase())
                .replace(":schema", this.props.selectedSchemaModel.name)
                .replace(":dataSetAction", "create"),
        );
    };

    showEditDataSet = (dataSetId) => {
        this.props.history.push(
            AppPaths.TENANT_SCHEMA_DATASET_ID_ACTION.replace(":tenant", this.props.tenant.toLowerCase())
                .replace(":businessarea", this.props.businessArea.toLowerCase())
                .replace(":schema", this.props.selectedSchemaModel.name)
                .replace(":dataSetId", dataSetId)
                .replace(":dataSetAction", "edit"),
        );
    };

    showViewDataSet = (dataSetId) => {
        this.props.history.push(
            AppPaths.TENANT_SCHEMA_DATASET_ID_ACTION.replace(":tenant", this.props.tenant.toLowerCase())
                .replace(":businessarea", this.props.businessArea.toLowerCase())
                .replace(":schema", this.props.selectedSchemaModel.name)
                .replace(":dataSetId", dataSetId)
                .replace(":dataSetAction", "view"),
        );
    };

    showDataSetHistory = (dataSetId) => {
        this.props.history.push(
            AppPaths.TENANT_SCHEMA_DATASET_ID_ACTION.replace(":tenant", this.props.tenant.toLowerCase())
                .replace(":businessarea", this.props.businessArea.toLowerCase())
                .replace(":schema", this.props.selectedSchemaModel.name)
                .replace(":dataSetId", dataSetId)
                .replace(":dataSetAction", "history"),
        );
    };

    showDataObjectBulkUpload = (dataSetName, source) => {
        this.props.history.push(
            `${AppPaths.TENANT_DATASET_DATAOBJECT_ACTION.replace(":tenant", this.props.tenant.toLowerCase())
                .replace(":businessarea", this.props.businessArea.toLowerCase())
                .replace(":schema", this.props.schema)
                .replace(":dataset", dataSetName)
                .replace(":dataObjectAction", "bulkupload")}#${source}`,
            {
                dataSetAction: this.props.action,
            },
        );
    };

    onIndexDataSet = (dataSet) => {
        this.setState({
            dataSetToIndex: dataSet,
            showIndexDataSetConfirmation: true,
            indexDataSetConfirmMessage: `Are you sure, you want to index '${dataSet.dataSetName}' Dataset records? Indexing would take time depending on the size of the dataset.`,
        });
    };

    onIndexDataSetConfirmed = () => {
        this.props.indexDataSet(this.state.dataSetToIndex);
        this.setState({
            dataSetToIndex: null,
            showIndexDataSetConfirmation: false,
            busy: true,
            busyMessage: "Creating index dataset records job...",
        });
    };

    onIndexDataSetCancel = () => {
        this.setState({
            dataSetToIndex: null,
            showIndexDataSetConfirmation: false,
        });
    };

    onExportDataSetToFile = (dataSet) => {
        this.setState({
            busy: true,
            busyMessage: "Creating export dataset job...",
        });
        this.props.exportDataSetToFile(dataSet);
    };

    onExportDataSetToSystemConnectionClick = (dataSet) => {
        this.props.history.push(
            AppPaths.TENANT_SCHEMA_DATASET_ID_ACTION.replace(":tenant", this.props.tenant.toLowerCase())
                .replace(":businessarea", this.props.businessArea.toLowerCase())
                .replace(":schema", this.props.selectedSchemaModel.name)
                .replace(":dataSetId", dataSet.dataSetId)
                .replace(":dataSetAction", "export"),
        );
    };

    onExportDataSetToSystemConnection = (connection) => {
        this.setState({
            busy: true,
            busyMessage: "Creating export dataset job...",
        });
        this.props.exportDataSetToSystemConnection(this.props.dataSet, connection);
    };

    onExportDataSetToSystemConnectionCancel = () => {
        this.props.history.push(
            `${AppPaths.TENANT_BUSINESS_AREA_SCHEMA.replace(":tenant", this.props.tenant.toLowerCase()).replace(
                ":businessarea",
                this.props.businessArea.toLowerCase(),
            )}${this.props.schemaModel ? `#${this.props.schemaModel.name}` : ""}`,
        );
    };

    closeExportJobCreatedResult = () => {
        this.setState({
            showExportJobCreatedResult: false,
        });
    };

    closeExportJobToSystemConnectionCreatedResult = () => {
        this.props.history.push(
            `${AppPaths.TENANT_BUSINESS_AREA_SCHEMA.replace(":tenant", this.props.tenant.toLowerCase()).replace(
                ":businessarea",
                this.props.businessArea.toLowerCase(),
            )}${this.props.schemaModel ? `#${this.props.schemaModel.name}` : ""}`,
        );
    };

    showDataObjectHistory = (dataSetName, dataObjectId) => {
        this.props.history.push(
            AppPaths.TENANT_DATASET_DATAOBJECT_ID_ACTION.replace(":tenant", this.props.tenant.toLowerCase())
                .replace(":businessarea", this.props.businessArea.toLowerCase())
                .replace(":schema", this.props.schema)
                .replace(":dataset", dataSetName)
                .replace(":dataObjectId", dataObjectId)
                .replace(":dataObjectAction", "history"),
        );
    };

    goToSchemas = () => {
        this.props.history.push(
            `${AppPaths.TENANT_BUSINESS_AREA_SCHEMA.replace(":tenant", this.props.tenant.toLowerCase()).replace(
                ":businessarea",
                this.props.businessArea.toLowerCase(),
            )}${this.props.schemaModel ? `#${this.props.schemaModel.name}` : ""}`,
        );
    };

    createDataSet = (dataSet, afterSaveCallback) => {
        this.setState({
            busy: true,
            busyMessage: "Creating dataset...",
            afterSaveCallback,
        });
        this.props.createDataSet(this.props.schemaModel.businessAreaId, this.props.schemaModel.schemaId, dataSet);
    };

    updateDataSet = (dataSet, updatedDataSet, afterSaveCallback) => {
        this.setState({
            busy: true,
            busyMessage: "Updating dataset...",
            afterSaveCallback,
        });
        this.props.updateDataSet(this.props.schemaModel.businessAreaId, this.props.schemaModel.schemaId, dataSet, updatedDataSet);
    };

    showDeleteDataSetConfirmation = (dataSet) => {
        this.setState({
            deletedDataSet: dataSet,
            showDataSetDeleteConfirmation: true,
            deleteDataSetConfirmMessage: `Are you sure, you want to delete '${dataSet.dataSetName}' Dataset?`,
        });
    };

    onDeleteDataSetConfirmed = () => {
        this.setState({
            busy: true,
            busyMessage: "Deleting dataset...",
        });
        this.props.deleteDataSet(this.props.selectedSchemaModel.businessAreaId, this.props.selectedSchemaModel.schemaId, this.state.deletedDataSet.dataSetId);
        this.onDeleteDataSetCancel();
    };

    onDeleteDataSetCancel = () => {
        this.setState({
            deletedDataSet: null,
            showDataSetDeleteConfirmation: false,
            deleteDataSetConfirmMessage: "",
        });
    };

    onDataSetValuesChanged = (changedValues, allValues) => {
        if (_.isEmpty(this.state.manageDataSetErrors) === false) {
            let manageDataSetErrors = { ...this.state.manageDataSetErrors };
            let flatObject = flatten(changedValues);
            for (let key in flatObject) {
                delete manageDataSetErrors[key];
            }
            this.setState({
                manageDataSetErrors,
            });
        }
    };

    getEmptyText = () => {
        if (!this.props.selectedSchemaModel) {
            return <EmptyDataRow description="Please select a schema."></EmptyDataRow>;
        }
        if (this.props.selectedSchemaModel) {
            if (this.state.fetchingSchemaDataSets) {
                return <EmptyDataRow></EmptyDataRow>;
            }
            return <EmptyDataRow description={`There are no data sets for schema - ${this.props.selectedSchemaModel.name}`}></EmptyDataRow>;
        }
        return "";
    };

    getNotFoundError = () => {
        if (!this.props.dataSet) {
            if (this.props.getDataSetByIdResult.success) {
                return {
                    title: "Dataset not found.",
                    description: "The dataset you are looking for does not exist.",
                };
            }
            return {
                title: "Dataset could not be fetched.",
                description: "An error occurred while fetching dataset. Please contact support.",
            };
        }
        return null;
    };

    getNextDataObjects = (dataSetId, pageKey) => {
        this.setState({
            fetchingNextPageDataObjects: true,
        });
        this.props.getDataObjectsByDataSetIdNextPage(this.props.schemaModel.businessAreaId, this.props.schemaModel.schemaId, dataSetId, pageKey);
    };

    getDataSetJobs = (dataSetId) => {
        this.props.getDataSetJobs(dataSetId);
        this.setState({
            fetchingDataSetJobs: true,
        });
    };

    onUndoJob = (jobId, version) => {
        this.setState({
            undoJobInProgress: true,
        });
        this.props.undoJob(jobId, version);
    };

    onDataObjectSelected = (dataObject) => {
        this.props.getDeDuplicatedRecords(dataObject.dataObjectId);
        setTimeout(() => {
            this.setState({
                loadingDataObjectForm: false,
                selectedDataObject: dataObject,
            });
        }, 500);
        this.setState({
            loadingDataObjectForm: true,
            fetchingDeDuplicatedRecords: true,
            showDataObjectFormContainer: true, // Only show side panel when data is selected
        });
    };

    onCreateNewDataObject = () => {
        this.setState({
            selectedDataObject: {},
            showDataObjectFormContainer: true, // Show side panel for edit
        });
    };

    createDataObject = (dataObject) => {
        this.setState({
            busy: true,
            busyMessage: "Creating dataset record...",
        });
        this.props.createDataObject(this.props.schemaModel.businessAreaId, this.props.schemaModel.schemaId, this.props.dataSet.dataSetId, dataObject);
    };

    updateDataObject = (dataObjectId, dataObject) => {
        this.setState({
            busy: true,
            busyMessage: "Updating dataset record...",
        });
        this.props.updateDataObject(this.props.schemaModel.businessAreaId, this.props.schemaModel.schemaId, this.props.dataSet.dataSetId, dataObjectId, dataObject);
    };

    showDeleteDataObjectConfirmation = (dataObjectId) => {
        this.setState({
            deletedDataObjectId: dataObjectId,
            showDataObjectDeleteConfirmation: true,
            deleteDataObjectConfirmMessage: `Are you sure, you want to delete dataset record?`,
        });
    };

    onDeleteDataObjectConfirmed = () => {
        this.setState({
            busy: true,
            busyMessage: "Deleting dataset record...",
        });
        this.props.deleteDataObject(this.props.schemaModel.businessAreaId, this.props.schemaModel.schemaId, this.props.dataSet.dataSetId, this.state.deletedDataObjectId);
        this.onDeleteDataObjectCancel();
    };

    onDeleteDataObjectCancel = () => {
        this.setState({
            deletedDataObjectId: null,
            showDataObjectDeleteConfirmation: false,
            deleteDataObjectConfirmMessage: "",
        });
    };

    closeDataObjectForm = () => {
        this.setState({
            selectedDataObject: null,
            showDataObjectFormContainer: false, // Hide side panel when no data is selected
        });
    };

    onValidationErrors = (dataObject, validationErrors) => {
        this.props.updateDataObjectValidationErrors(dataObject, validationErrors);
    };

    goToJobs = () => {
        this.props.history.push(AppPaths.TENANT_MONITOR_ITEM.replace(":tenant", this.props.tenant.toLowerCase()).replace(":monitorItem", "jobs"));
    };

    onSidePanelActiveTabChanged = (activeKey) => {
        this.setState({
            sidePanelActiveTab: activeKey,
        });
    };
    renderLocationContainer = () => {
        const findFieldByName = (name) => {
            return this.props.schemaModel.fields.find((field) => name.some((pattern) => field.name.toLowerCase().includes(pattern)));
        };
        const findFieldByClassifier = (classifierTags) => {
            return this.props.schemaModel.fields.find(
                (field) => field.classifiers && field.classifiers.some((obj) => classifierTags.some((tag) => obj["tagName"].toLowerCase() === tag.toLowerCase())),
            );
        };
        const findFieldByDataType = (dataType) => {
            return this.props.schemaModel.fields.find((field) => dataType.some((type) => field.dataType.toLowerCase() === type.toLowerCase()));
        };

        const latitudeField = findFieldByName(["latitude", "lat"]);
        const longitudeField = findFieldByName(["longitude", "long", "lng"]);
        const directAddressField = findFieldByName(["address", "location", "addr", "full_address"]);
        const geocodeField = findFieldByName(["geocode", "geocoordinates", "coordinates", "coords"]);

        const latitudeFieldByTag = findFieldByClassifier(["latitude", "geolatitude"]);
        const longitudeFieldByTag = findFieldByClassifier(["longitude", "geolongitude"]);
        const addressFieldByTag = findFieldByClassifier(["address", "location"]);
        const geocodeFieldByTag = findFieldByClassifier(["geocode", "geocoordinates", "coordinates"]);

        const latitudeFieldByType = findFieldByDataType(["geolatitude"]);
        const longitudeFieldByType = findFieldByDataType(["geolongitude"]);
        const geocodeFieldByType = findFieldByDataType(["geocoordinates"]);

        const finalLatitudeField = latitudeFieldByType || latitudeFieldByTag || latitudeField;
        const finalLongitudeField = longitudeFieldByType || longitudeFieldByTag || longitudeField;
        const finalDirectAddressField = addressFieldByTag || directAddressField;
        const finalGeocodeField = geocodeFieldByType || geocodeFieldByTag || geocodeField;

        const addressComponents = [
            { key: "building", patterns: ["building", "bldg", "unit", "suite"] },
            { key: "street", patterns: ["street", "road", "st", "rd", "address_line_1"] },
            { key: "locality", patterns: ["locality", "area", "neighborhood"] },
            { key: "city", patterns: ["city", "town", "municipality"] },
            { key: "state", patterns: ["state", "province", "region"] },
            { key: "country", patterns: ["country", "nation"] },
            { key: "zip", patterns: ["zip", "zipcode", "postal_code", "postcode"] },
        ];

        const addressFields = {};

        addressComponents.forEach((component) => {
            const fieldByTag = findFieldByClassifier(component.patterns);
            const fieldByName = findFieldByName(component.patterns);
            addressFields[component.key] = fieldByTag || fieldByName;
        });

        const hasSupplementaryFields = Object.values(addressFields).some(Boolean);

        let addressField = "";

        if (finalDirectAddressField && hasSupplementaryFields) {
            addressField = [
                this.state.selectedDataObject[finalDirectAddressField.fieldId],
                ...Object.values(addressFields)
                    .filter(Boolean)
                    .map((field) => this.state.selectedDataObject[field.fieldId]),
            ]
                .filter(Boolean)
                .join(", ");
        } else if (finalDirectAddressField) {
            addressField = this.state.selectedDataObject[finalDirectAddressField.fieldId];
        } else if (hasSupplementaryFields) {
            addressField = Object.values(addressFields)
                .filter(Boolean)
                .map((field) => this.state.selectedDataObject[field.fieldId])
                .join(", ");
        }

        if (addressField) {
            return <LocationContainer selectedDataObject={addressField} />;
        }

        // Fallback to latitude and longitude if addressField is not present
        if (finalLatitudeField && finalLongitudeField) {
            return (
                <LocationContainer
                    markers={[
                        {
                            position: {
                                latitude: this.state.selectedDataObject[finalLatitudeField.fieldId].toString(),
                                longitude: this.state.selectedDataObject[finalLongitudeField.fieldId],
                            },
                        },
                    ]}
                />
            );
        }
        if (finalGeocodeField) {
            let geocodeValue = this.state.selectedDataObject[finalGeocodeField.fieldId];
            const [latitude, longitude] = geocodeValue.split(",").map((coord) => parseFloat(coord.trim()));
            return <LocationContainer markers={[{ position: { latitude, longitude } }]} />;
        }

        return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No location field found. Cannot show location details." />;
    };

    getDataSetComponent = () => {
        if (!this.props.action) {
            return (
                <>
                    <SuccessResult
                        show={this.state.showExportJobCreatedResult}
                        title="Export dataset to a file job created!"
                        subTitle="A job is created. File will be available in the job for download once job is completed."
                        okText="Go to jobs"
                        cancelText="Close"
                        onOkClick={this.goToJobs}
                        onCancelClick={this.closeExportJobCreatedResult}
                    ></SuccessResult>
                    <SuccessResult
                        show={this.state.showExportJobToSystemConnectionCreatedResult}
                        title="Export dataset to a system connection job created!"
                        subTitle="A job is created. Dataset records would be exported to selected destination once job is completed."
                        okText="Go to jobs"
                        cancelText="Close"
                        onOkClick={this.goToJobs}
                        onCancelClick={this.closeExportJobToSystemConnectionCreatedResult}
                    ></SuccessResult>
                    <OkCancelConfirmationBox
                        show={this.state.showDataSetDeleteConfirmation}
                        message={this.state.deleteDataSetConfirmMessage}
                        onCancel={this.onDeleteDataSetCancel}
                        onOk={this.onDeleteDataSetConfirmed}
                    ></OkCancelConfirmationBox>
                    <OkCancelConfirmationBox
                        show={this.state.showIndexDataSetConfirmation}
                        message={this.state.indexDataSetConfirmMessage}
                        onCancel={this.onIndexDataSetCancel}
                        onOk={this.onIndexDataSetConfirmed}
                    ></OkCancelConfirmationBox>
                    <DataSetList
                        permission={this.props.selectedSchemaModel ? this.state.dataSetPermission : {}}
                        allowCreateNew={this.props.selectedSchemaModel && !this.state.fetchingSchemaDataSets ? true : false}
                        dataSetList={this.state.fetchingSchemaDataSets || !this.props.selectedSchemaModel ? [] : this.props.schemaDataSetResult.Items}
                        parentSchema={this.props.selectedSchemaModel && this.props.selectedSchemaModel.name}
                        emptyText={this.getEmptyText()}
                        onCreateNewDataSet={this.showCreateDataSet}
                        onEditDataSet={this.showEditDataSet}
                        onDeleteDataSet={this.showDeleteDataSetConfirmation}
                        onViewDataSet={this.showViewDataSet}
                        onViewDataSetHistory={this.showDataSetHistory}
                        onIndexDataSet={this.onIndexDataSet}
                        onExportToFileClick={this.onExportDataSetToFile}
                        onExportToSystemConnectionClick={this.onExportDataSetToSystemConnectionClick}
                        exportPermission={this.props.exportPermission}
                    ></DataSetList>
                </>
            );
        }
        let notFoundError = this.getNotFoundError();

        switch (this.props.action.toLowerCase()) {
            case "create":
                return (
                    <ManageDataSet
                        permission={this.state.dataSetPermission}
                        schemaModel={this.props.schemaModel}
                        formErrors={this.state.manageDataSetErrors}
                        onValuesChanged={this.onDataSetValuesChanged}
                        action={this.props.action}
                        onBulkUploadData={this.showDataObjectBulkUpload}
                        onCreateDataSet={this.createDataSet}
                        onCancel={this.goToSchemas}
                    ></ManageDataSet>
                );
            case "view":
            case "edit":

                return !notFoundError ? (
                    <div className="flex size-full flex-auto gap-4 overflow-auto">
                        <OkCancelConfirmationBox
                            show={this.state.showDataObjectDeleteConfirmation}
                            message={this.state.deleteDataObjectConfirmMessage}
                            onCancel={this.onDeleteDataObjectCancel}
                            onOk={this.onDeleteDataObjectConfirmed}
                        ></OkCancelConfirmationBox>
                        <ManageDataSet
                            permission={this.state.dataSetPermission}
                            schemaModel={this.props.schemaModel}
                            dataSet={this.props.dataSet}
                            formErrors={this.state.manageDataSetErrors}
                            onValuesChanged={this.onDataSetValuesChanged}
                            action={this.props.action}
                            onBulkUploadData={this.showDataObjectBulkUpload}
                            onUpdateDataSet={this.updateDataSet}
                            loadingDataObjects={this.state.fetchingDataObjects}
                            loadingNextPageDataObjects={this.state.fetchingNextPageDataObjects}
                            dataObjectsResult={this.props.dataObjectsByDataSetIdResult}
                            dataObjects={this.props.dataObjectsByDataSetIdResult.Items}
                            onGetNextDataObjects={this.getNextDataObjects}
                            onCancel={this.goToSchemas}
                            onGetBatchUploadJobs={this.getDataSetJobs}
                            fetchingBatchUploadJobs={this.state.fetchingDataSetJobs}
                            jobList={this.props.jobsResult.Items}
                            undoJob={this.onUndoJob}
                            undoJobInProgress={this.state.undoJobInProgress}
                            refreshDataObjects={this.getDataSetObjects}
                            onDataObjectSelected={this.onDataObjectSelected}
                            onCreateNewDataObject={this.onCreateNewDataObject}
                            onShowDataObjectHistory={this.showDataObjectHistory}
                            onDeleteDataObject={this.showDeleteDataObjectConfirmation}
                            bulkVerification={true}
                        ></ManageDataSet>
                        {!!this.state.showDataObjectFormContainer && (
                            <div className="flex h-full w-[400px] flex-none flex-col overflow-auto rounded-md border border-gray-200 p-4">
                                <MenuPanelContainer
                                    recordKeys={{
                                        DATASET_RECORD: "Dataset Record",
                                        DEDUPLICATION_HISTORY: "Deduplication History",
                                        DATA_OBJECT_VERIFICATION: "Verification",
                                        DATA_OBJECT_CONSENT: "Consent",
                                        LOCATION_ACTIVE: "Location",
                                    }}
                                    selectedKey={this.state.sidePanelActiveTab}
                                    onChange={this.onSidePanelActiveTabChanged}
                                >
                                    {this.state.sidePanelActiveTab === "DATASET_RECORD" &&
                                        (this.state.loadingDataObjectForm ? (
                                            <LoadingOverlay busy={true} message="Please wait..."></LoadingOverlay>
                                        ) : (
                                            <BasicFormBuilder
                                                key={this.state.selectedDataObject ? this.state.selectedDataObject.dataObjectId : "new_dataobject"}
                                                showHeader={false}
                                                formDataObject={this.state.selectedDataObject}
                                                schemaFields={(this.props.schemaModel && this.props.schemaModel.fields) || []}
                                                onCreate={this.createDataObject}
                                                onUpdate={this.updateDataObject}
                                                onCancel={this.closeDataObjectForm}
                                                onValidationErrors={this.onValidationErrors}
                                                requestVerification={true}
                                                showRevealButton={true}
                                                maskPIIFields={true}
                                                readOnly={!this.props.dataObjectPermission?.canEdit || this.props.action === "view"}
                                            ></BasicFormBuilder>
                                        ))}
                                    {this.state.sidePanelActiveTab === "DEDUPLICATION_HISTORY" &&
                                        (this.state.fetchingDeDuplicatedRecords ? (
                                            <LoadingOverlay busy={true} message="Getting records..."></LoadingOverlay>
                                        ) : (
                                            <DeduplicatedRecordsTable
                                                items={
                                                    this.state.selectedDataObject && this.state.selectedDataObject.dataObjectId ? this.props.deDuplicatedRecordsResult.Items : []
                                                }
                                            ></DeduplicatedRecordsTable>
                                        ))}
                                    {this.state.sidePanelActiveTab === "DATA_OBJECT_VERIFICATION" && this.state.selectedDataObject && (
                                        <DataObjectVerifications
                                            key={this.state.selectedDataObject.dataObjectId}
                                            businessAreaId={this.state.selectedDataObject.businessAreaId}
                                            schemaId={this.state.selectedDataObject.schemaId}
                                            dataObjectId={this.state.selectedDataObject.dataObjectId}
                                        ></DataObjectVerifications>
                                    )}
                                    {this.state.sidePanelActiveTab === "DATA_OBJECT_CONSENT" &&
                                        (this.state.sidePanelActiveTab === "DATA_OBJECT_CONSENT" ? (
                                            this.state.selectedDataObject && (
                                                <DataObjectConsents
                                                    key={this.state.selectedDataObject.dataObjectId}
                                                    dataObjectId={this.state.selectedDataObject.dataObjectId}
                                                ></DataObjectConsents>
                                            )
                                        ) : (
                                            <></>
                                        ))}
                                    {this.state.sidePanelActiveTab === "LOCATION_ACTIVE" &&
                                        (this.state.selectedDataObject ? (
                                            this.renderLocationContainer()
                                        ) : (
                                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Choose a row to view location details." />
                                        ))}
                                </MenuPanelContainer>
                            </div>
                        )}
                    </div>
                ) : (
                    <NotFoundError title={notFoundError.title} description={notFoundError.description}></NotFoundError>
                );
            case "history":
                return !notFoundError ? (
                    this.state.showHistory ? (
                        <DataSetAudit dataSet={this.props.dataSet}></DataSetAudit>
                    ) : (
                        <></>
                    )
                ) : (
                    <NotFoundError title={notFoundError.title} description={notFoundError.description}></NotFoundError>
                );
            case "export":
                return !notFoundError ? (
                    <>
                        <SuccessResult
                            show={this.state.showExportJobToSystemConnectionCreatedResult}
                            title="Export dataset to a system connection job created!"
                            subTitle="A job is created. Dataset records would be exported to selected destination once job is completed."
                            okText="Go to jobs"
                            cancelText="Close"
                            onOkClick={this.goToJobs}
                            onCancelClick={this.closeExportJobToSystemConnectionCreatedResult}
                        ></SuccessResult>
                        <DataSetExport
                            businessAreaId={this.props.schemaModel.businessAreaId}
                            onExport={this.onExportDataSetToSystemConnection}
                            onCancel={this.onExportDataSetToSystemConnectionCancel}
                        ></DataSetExport>
                    </>
                ) : (
                    <NotFoundError title={notFoundError.title} description={notFoundError.description}></NotFoundError>
                );
            default:
                return <ProhibitedArea></ProhibitedArea>;
        }
    };

    render() {
        if (this.state.permissionDenied) {
            return <ProhibitedArea></ProhibitedArea>;
        }
        return (
            <div className="relative flex flex-1 flex-col overflow-auto">
                <LoadingOverlay busy={this.isBusy()} spinner message={this.state.busyMessage || "Please wait..."}></LoadingOverlay>
                {!this.loadingComponentData() && this.getDataSetComponent()}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getUserDataSetPermissionResult: state.dataSets.getUserDataSetPermissionResult,
        dataSetPermission: state.dataSets.permission,
        getSchemaDataSetResult: state.dataSets.getSchemaDataSetResult,
        recentDataSetListResult: state.dataSets.recentDataSetListResult,
        schemaDataSetResult: state.dataSets.schemaDataSetResult,
        createDataSetResult: state.dataSets.createDataSetResult,
        schemaModel: state.schemaModels.schemaModel,
        schemaPermission: state.schemaModels.permission,
        getDataSetByIdResult: state.dataSets.getDataSetByIdResult,
        dataSet: state.dataSets.dataSet,
        updateDataSetResult: state.dataSets.updateDataSetResult,
        deleteDataSetResult: state.dataSets.deleteDataSetResult,
        getDataObjectsByDataSetIdResult: state.dataObjects.getDataObjectsByDataSetIdResult,
        dataObjectsByDataSetIdResult: state.dataObjects.dataObjectsByDataSetIdResult,
        getDataObjectsByDataSetIdNextPageResult: state.dataObjects.getDataObjectsByDataSetIdNextPageResult,
        getJobsResult: state.dataSets.getJobsResult,
        jobsResult: state.dataSets.jobsResult,
        undoJobResult: state.dataSets.undoJobResult,
        createDataObjectResult: state.dataObjects.createDataObjectResult,
        updateDataObjectResult: state.dataObjects.updateDataObjectResult,
        deleteDataObjectResult: state.dataObjects.deleteDataObjectResult,
        getDataObjectResult: state.dataObjects.getDataObjectResult,
        dataObject: state.dataObjects.dataObject,
        indexDataSetResult: state.dataSets.indexDataSetResult,
        exportDataSetToFileResult: state.dataSets.exportDataSetToFileResult,
        exportDataSetToSystemConnectionResult: state.dataSets.exportDataSetToSystemConnectionResult,
        exportPermission: state.dataSets.exportPermission,
        getDeDuplicatedRecordsRequestResult: state.dataObjectDuplicateSearch.getDeDuplicatedRecordsRequestResult,
        deDuplicatedRecordsResult: state.dataObjectDuplicateSearch.deDuplicatedRecordsResult,
        getDataObjectPermissionResult: state.dataObjects.getDataObjectPermissionResult,
        dataObjectPermission: state.dataObjects.dataObjectPermission,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUserDataSetPermission: () => dispatch(actions.getUserDataSetPermissionRequest()),
        getDataSetBySchemaId: (businessAreaId, schemaId) => dispatch(actions.getDataSetBySchemaIdRequest(businessAreaId, schemaId)),
        createDataSet: (businessAreaId, schemaId, dataSet) => dispatch(actions.createDataSetRequest(businessAreaId, schemaId, dataSet)),
        getDataSetById: (businessAreaId, schemaId, dataSetId) => dispatch(actions.getDataSetByIdRequest(businessAreaId, schemaId, dataSetId)),
        updateDataSet: (businessAreaId, schemaId, dataSet, updatedDataSet) => dispatch(actions.updateDataSetRequest(businessAreaId, schemaId, dataSet, updatedDataSet)),
        deleteDataSet: (businessAreaId, schemaId, dataSetId) => dispatch(actions.deleteDataSetRequest(businessAreaId, schemaId, dataSetId)),
        getDataObjectsByDataSetId: (businessAreaId, schemaId, dataSetId) => dispatch(actions.getDataObjectsByDataSetIdRequest(businessAreaId, schemaId, dataSetId)),
        getDataObjectsByDataSetIdNextPage: (businessAreaId, schemaId, dataSetId, pageKey) =>
            dispatch(actions.getDataObjectsByDataSetIdNextPageRequest(businessAreaId, schemaId, dataSetId, pageKey)),
        getDataSetJobs: (dataSetId) => dispatch(actions.getDataSetJobsRequest(dataSetId)),
        undoJob: (jobId, version) => dispatch(actions.undoJobRequest(jobId, version)),
        createDataObject: (businessAreaId, schemaId, dataSetId, dataObject) => dispatch(actions.createDataObjectRequest(businessAreaId, schemaId, dataSetId, dataObject)),
        updateDataObject: (businessAreaId, schemaId, dataSetId, dataObjectId, dataObject) =>
            dispatch(actions.updateDataObjectRequest(businessAreaId, schemaId, dataSetId, dataObjectId, dataObject)),
        updateDataObjectValidationErrors: (dataObject, validationErrors) => dispatch(actions.updateDataObjectValidationErrorsRequest(dataObject, validationErrors)),
        deleteDataObject: (businessAreaId, schemaId, dataSetId, dataObjectId) => dispatch(actions.deleteDataObjectRequest(businessAreaId, schemaId, dataSetId, dataObjectId)),
        indexDataSet: (dataSet) => dispatch(actions.indexDataSetRequest(dataSet)),
        exportDataSetToFile: (dataSet) => dispatch(actions.exportDataSetToFileRequest(dataSet)),
        exportDataSetToSystemConnection: (dataSet, connection) => dispatch(actions.exportDataSetToSystemConnectionRequest(dataSet, connection)),
        getUserExportJobPermission: () => dispatch(actions.getUserExportJobPermissionRequest()),
        getDeDuplicatedRecords: (survivedRecordId) => dispatch(actions.getDeDuplicatedRecordsRequest(survivedRecordId)),
        getDataObjectPermission: () => dispatch(actions.getDataObjectPermissionRequest()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DataSets));
